module.exports = __webpack_public_path__ + "img/jane-johnson.4aa66cc9.png";